import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';

//root is an ID
ReactDOM.render(<App />, document.getElementById('root'));